export const colorsBg = {
  white: ['bg-theme-surface text-theme-text dark:bg-theme-brand-hover dark:text-theme-text'],
  light: ['bg-theme-bg-subtle text-theme-text'],
  success: ['bg-theme-palette-emerald text-theme-text-inverse'],
  danger: ['bg-theme-palette-red text-theme-text-inverse'],
  warning: ['bg-theme-palette-yellow text-theme-text-inverse'],
  info: ['bg-theme-palette-blue text-theme-text-inverse'],
  indigo: ['bg-theme-palette-indigo text-theme-text-inverse'],
};

export const colorsBorders = {
  white: ['border-theme-border dark:border-theme-brand'],
  light: ['border-theme-border dark:border-theme-border-strong'],
  success: ['border-theme-palette-emerald'],
  danger: ['border-theme-palette-red'],
  warning: ['border-theme-palette-yellow'],
  info: ['border-theme-palette-blue'],
  indigo: ['border-theme-palette-indigo'],
};

export const colorsText = {
  white: ['text-theme-text dark:text-theme-text'],
  light: ['text-theme-text-secondary dark:text-theme-text-muted'],
  success: ['text-theme-palette-emerald'],
  danger: ['text-theme-palette-red'],
  warning: ['text-theme-palette-yellow'],
  info: ['text-theme-palette-blue'],
  indigo: ['text-theme-palette-indigo'],
};

export const colorsOutline = {
  white: [...colorsText.white, ...colorsBorders.white],
  light: [...colorsText.light, ...colorsBorders.light],
  success: [...colorsText.success, ...colorsBorders.success],
  danger: [...colorsText.danger, ...colorsBorders.danger],
  warning: [...colorsText.warning, ...colorsBorders.warning],
  info: [...colorsText.info, ...colorsBorders.info],
  indigo: [...colorsText.indigo, ...colorsBorders.indigo],
};

export const colorsButtons = {
  white: ['hover:bg-theme-bg-subtle dark:hover:bg-theme-brand', ...colorsBg.white, ...colorsBorders.white],
  light: ['hover:bg-theme-surface-raised', ...colorsBg.light, ...colorsBorders.light],
  success: ['hover:bg-theme-palette-emerald', ...colorsBg.success, ...colorsBorders.success],
  danger: ['hover:bg-theme-palette-red', ...colorsBg.danger, ...colorsBorders.danger],
  warning: ['hover:bg-theme-palette-yellow', ...colorsBg.warning, ...colorsBorders.warning],
  info: ['hover:bg-theme-palette-blue', ...colorsBg.info, ...colorsBorders.info],
  indigo: ['hover:bg-theme-palette-indigo', ...colorsBg.indigo, ...colorsBorders.indigo],
};

export const colorsButtonsOutline = {
  white: [
    'hover:bg-theme-bg-subtle hover:text-theme-text dark:hover:bg-theme-brand-hover dark:hover:text-theme-text',
    ...colorsText.white,
    ...colorsBorders.white,
  ],
  light: [
    'hover:bg-theme-bg-subtle hover:text-theme-text dark:hover:text-theme-text',
    ...colorsText.light,
    ...colorsBorders.light,
  ],
  success: [
    'hover:bg-theme-palette-emerald hover:text-theme-text-inverse',
    ...colorsText.success,
    ...colorsBorders.success,
  ],
  danger: ['hover:bg-theme-palette-red hover:text-theme-text-inverse', ...colorsText.danger, ...colorsBorders.danger],
  warning: [
    'hover:bg-theme-palette-yellow hover:text-theme-text-inverse',
    ...colorsText.warning,
    ...colorsBorders.warning,
  ],
  info: ['hover:bg-theme-palette-blue hover:text-theme-text-inverse', ...colorsText.info, ...colorsBorders.info],
  indigo: ['hover:bg-theme-palette-indigo hover:text-theme-text-inverse', ...colorsText.indigo, ...colorsBorders.indigo],
};

export const controlTextColor = (error, success) => {
  if (error) {
    return 'text-theme-palette-red';
  }

  if (success) {
    return 'text-theme-palette-green';
  }

  return null;
};
